module.exports = __webpack_public_path__ + "f92af0e6b6a35b239ac2a8e146c161bf.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-04-24/whats-new.html
// module id = 2314
// module chunks = 0